import { useCallback, useEffect, useRef, useState } from 'react';
import { addDismissOnEscape, addDismissOnOutsidePointerDown } from '../lib/dismissListeners';

export function useDropdownMenu({ focusRef } = {}) {
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    return addDismissOnOutsidePointerDown({
      rootEl: rootRef.current,
      onDismiss: () => setOpen(false),
    });
  }, [open]);

  useEffect(() => {
    if (!open) return;
    return addDismissOnEscape({
      onDismiss: () => setOpen(false),
      focusEl: focusRef?.current ?? null,
    });
  }, [open, focusRef]);

  const toggleOpen = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const close = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    rootRef,
    open,
    setOpen,
    toggleOpen,
    close,
  };
}
